import {post} from '../request'


/**
 * 用户登录
 * @param data
 * @returns {*}
 */
export function Login(data) {
	return post("o2o.admin.passport/login", data)
}

/**
 * 用户登录
 * @param data
 * @returns {*}
 */
export function adminLogin(data) {
	return post("o2o.admin.passport/adminLogin", data)
}

